///<reference path='../../../core/services/resource.service.ts'/>
///<reference path='../../../core/services/guid.service.ts'/>
'use strict';

namespace TR {
    class Agent {

        signedIn: boolean;
        lightbox: boolean;
        agent;
        oldPassword;
        newPassword;
        confirmNewPassword;
        saveUsername: boolean = false;
        agentSigninModel = {
            username: '',
            password: ''
        };
        resetStatusText;
        username;

        constructor(
            private agentModeService,
            private $location: ng.ILocationService,
            private $scope: ng.IScope,
            private currentUser: any,
            private $q: ng.IQService,
            private resourceService: Core.ResourceService,
            private broker: Core.Broker,
            private basketStore: any,
            private guidService: Core.GuidService,
            private modalService: any,
            private cookieService: any,
            private rootPath: Core.RootPath,
            private $routeParams
            ) {
            //this.modalService.launch('partials/agents/signin', {}, true);
            this.lightbox = true;
            this.signedIn = !!this.currentUser.get().Agent;
            if (this.signedIn) {
                this.agentModeService.getAgentInformation().then(data => {
                    this.agent = data;

                    if (this.$location.search().Dest) {
                        this.doRedirect();
                    }
                });
            }
            this.agentSigninModel.username = cookieService.get('trpUsername') || '';
        }

        doRedirect() {
            const rootpath = this.rootPath.getRootPath();
            const dest = this.$location.search().Dest || '/';

            window.location.href = dest.substr(0,1) === '/' ? dest : `${rootpath}${dest}`;
        }

        updateDebugCookie() {
            this.agentModeService.updateDebugSettings(TRPCONFIG.Domain.AgentDebugSettings).then( () => {
                this.doRedirect();
            }, () => {
                this.doRedirect();
            });
        }

        signin(model) {
            if (TRPCONFIG.Domain.SessionOnlyAgentCookie) {
                model.sessionOnly = true;
            }
            this.agentModeService.signin(model).then(data => {
                if (data.Success) {
                    this.basketStore.createBasket().then(() => {
                        this.broker.publish('agentSignIn');
                        if (this.saveUsername) {
                            this.cookieService.set('trpUsername', model.username);
                        }
                        this.updateDebugCookie();
                    });
                } else {
                    this.$scope.$broadcast('flash:error', this.resourceService.get('SIGNINFAILURE'));
                    return this.$q.reject(data);
                }
            }, res => {
                this.$scope.$broadcast('flash:error', this.resourceService.get('SIGNINFAILURE'));
                return this.$q.reject(res);
            });
        }

        signout() {
            this.agentModeService.signout().then(() => this.doRedirect());
        }

        changePassword() {
            if (this.newPassword !== this.confirmNewPassword) {
                this.$scope.$emit('flash:error', this.resourceService.get('NEWPASWORDSDONTMATCH'));
            }
            else {
                this.agentModeService.changePassword(this.oldPassword, this.newPassword).then(data => {
                    if (data.Status === 0 && data.Success) {
                        this.$location.path('');
                    }
                    else if (data.Status === 1) {
                        this.$scope.$emit('flash:error', this.resourceService.get('USEDPASSWORD'));
                    }
                    else if (data.Status === 2) {
                        this.$scope.$emit('flash:error', this.resourceService.get('INCORRECTFORMAT'));
                    }
                    else if (data.Status === 3) {
                        this.$scope.$emit('flash:error', this.resourceService.get('PASSWORDTOOSMALL'));
                    }
                    else if (data.Status === 4) {
                        this.$scope.$emit('flash:error', this.resourceService.get('INVALIDVERIFICATION'));
                    }
                });
            }
        }

        initiateReset() {
            this.resetStatusText = null;
            this.$scope.$emit('flash:error', null);
            this.agentModeService.resetPasswordInitiate(this.username).then(data => {
                if (data.Result === 0) {
                    this.resetStatusText = this.resourceService.get('PASSWORDRESETINITIATED');
                }
                else if (data.Result === 3) {
                    this.$scope.$emit('flash:error', this.resourceService.get('PASSWORDRESETFAILEDACCOUNTDISABLED'));
                }
                else {
                    this.$scope.$emit('flash:error', this.resourceService.get('PASSWORDRESETFAILED'));
                }
            }, res => { this.$scope.$emit('flash:error', this.resourceService.get('PASSWORDRESETFAILED')); });
        }

        resetPassword() {
            this.$scope.$emit('flash:error', null);
            if (this.newPassword !== this.confirmNewPassword) {
                this.$scope.$emit('flash:error', this.resourceService.get('NEWPASWORDSDONTMATCH'));
                return;
            }
            this.agentModeService.resetPassword(this.newPassword, this.$routeParams.token).then(data => {
                if (data.Status === 0 && data.Result === 0) {
                    this.$location.path('agents/resetsuccessful');
                }
                else if (data.Status === 1) {
                    this.$scope.$emit('flash:error', this.resourceService.get('USEDPASSWORD'));
                }
                else if (data.Status === 2) {
                    this.$scope.$emit('flash:error', this.resourceService.get('INCORRECTFORMAT'));
                }
                else if (data.Status === 3) {
                    this.$scope.$emit('flash:error', this.resourceService.get('PASSWORDTOOSMALL'));
                }
                else if (data.Status === 4) {
                    this.$scope.$emit('flash:error', this.resourceService.get('INVALIDVERIFICATION'));
                }
            }, res => { this.$scope.$emit('flash:error', this.resourceService.get('INVALIDRESETURL')); });
        }

    }

    angular
    .module('TR')
    .controller('Agent', Agent);
}
